import React from "react";
import SomethingWentWrong from "../SomethingWentWrong";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: undefined,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidMount(): void {
    if(this.state.hasError) console.log(this.state.error?.message)
  }

  render() {
    if (this.state.hasError) {
      return <SomethingWentWrong />
    }
    return this.props.children;
  }
}

export default ErrorBoundary;